import { Skeleton, styled } from '@mui/material'

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.surface['900'],
}))

export const PillSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.surface['800'],
  borderRadius: theme.spacing(4),
  height: '48px',
  width: theme.spacing(18),
  display: 'flex',
  alignItems: 'center',
}))

export const DescriptionSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.surface['800'],
  height: '100px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
}))

export const AvatarSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.surface['800'],
  borderRadius: '50%',
  height: '155px',
  width: '155px',
  [theme.breakpoints.up('sm')]: {
    height: '194px',
    width: '194px',
    marginRight: theme.spacing(4),
    marginBottom: 0,
  },
  [theme.breakpoints.up('md')]: {
    height: '250px',
    width: '250px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '287px',
    width: '287px',
  },
}))
